import React, { memo, PropsWithChildren, ReactNode, cloneElement } from 'react';
import { useLocation, matchPath } from 'react-router-dom';
import { useOptionalRouteMatch } from './RouteContext';
import { getRoutePath } from './utils';

export const Switch = memo((props: PropsWithChildren<{ name?: string }>) => {
  const location = useLocation();
  const match = useOptionalRouteMatch();

  let routeElement: ReactNode = null;
  let redirectElement: ReactNode = null;

  let computedPath: string | undefined = undefined;

  React.Children.forEach(props.children, child => {
    if (!computedPath && React.isValidElement(child)) {
      let route: ReactNode;
      let redirect: ReactNode;

      let path: string | string[] | undefined | undefined;

      if (child.props.absolutePath || child.props.path) {
        route = child;

        path = getRoutePath(child.props.absolutePath, child.props.path, match?.path);
      } else if (child.props.absoluteFrom || child.props.from) {
        redirect = child;

        path = getRoutePath(child.props.absoluteFrom, child.props.from, match?.path);
      }

      const submatch = matchPath(location.pathname, {
        path,
        exact: child.props.exact,
        strict: child.props.strict,
        sensitive: child.props.sensitive,
      });

      if (submatch) {
        computedPath = submatch.path;

        if (route) routeElement = route;
        if (redirect) redirectElement = redirect;
      }
    }
  });

  if (redirectElement) {
    return cloneElement(redirectElement, { computedFrom: computedPath });
  }

  if (routeElement) {
    return cloneElement(routeElement, { computedPath });
  }

  return null;
});
